'use client'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { uniqueUserBidsQuery } from '@b-stock/fe-core/bstock-next/queries'

import { getDashboardBidsParams } from './dashboardBidsParams'

export { DASHBOARD_BIDS_FETCH_LIMIT } from './dashboardBidsParams'

export const useDashboardBids = () => {
  const accountId = useDecodedAccessToken()?.accountId ?? null

  return uniqueUserBidsQuery.useWithOpts([getDashboardBidsParams(accountId)], {
    enabled: accountId != null,
  })
}
